import { render, staticRenderFns } from "./DepositCampaignMarquee.vue?vue&type=template&id=26a313aa&"
import script from "./DepositCampaignMarquee.vue?vue&type=script&lang=js&"
export * from "./DepositCampaignMarquee.vue?vue&type=script&lang=js&"
import style0 from "./DepositCampaignMarquee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports